import { useLingui } from "@lingui/react";
import { UiDivider, UiIconButton, UiIconPolotno, UiList } from "@smp/ui";
import {
  IconBrandGoogleAnalytics,
  IconBusinessplan,
  IconCalendarTime,
  IconCreditCard,
  IconFlame,
  IconFolder,
  IconHelp,
  IconMenu2,
  IconRss,
  IconSchool,
  IconUserPlus,
  IconUsers,
} from "@tabler/icons-react";
import { useMemo } from "react";

import { DrawerItemMock } from "./drawer_item_mock";
import { useStyles } from "./drawer_mock.css";
import { TimeMock } from "./time_mock";

export const DrawerMock = () => {
  const classes = useStyles();
  const {
    i18n: { locale },
  } = useLingui();

  return useMemo(
    () => (
      <div className={classes.drawer}>
        <div className={classes.drawer__header}>
          <UiIconButton onClick={() => {}}>
            <IconMenu2 className={classes.drawer__header_icon} />
          </UiIconButton>
        </div>
        <div className={classes.drawer__list}>
          <UiList>
            <DrawerItemMock Icon={IconCalendarTime} />
            <DrawerItemMock Icon={IconBrandGoogleAnalytics} />
            <DrawerItemMock Icon={UiIconPolotno} />
            <DrawerItemMock Icon={IconFolder} />
            <DrawerItemMock Icon={IconRss} />
            <DrawerItemMock Icon={IconUserPlus} />
            <DrawerItemMock Icon={IconUsers} />
            <DrawerItemMock Icon={IconCreditCard} />
            <DrawerItemMock Icon={IconBusinessplan} />
            <DrawerItemMock Icon={IconFlame} />
          </UiList>
        </div>
        {locale === "ru" && <DrawerItemMock Icon={IconSchool} />}
        <DrawerItemMock Icon={IconHelp} />
        <UiDivider />
        <div className={classes.drawer__time}>
          <TimeMock />
        </div>
      </div>
    ),
    [classes, locale],
  );
};
